<template>
  <div>
    <slot
      :back="back"
      :is-loading="isLoading"
      :is-recommend-vet-experiment="isRecommendVetExperiment"
      :show-header-back-button="showHeaderBackButton"
      :toggle-filters="toggleFilters"
    />
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

import useSearchData from '@/composables/use-search-data';

export default {
  name: 'VetsterSearchNav',

  props: {
    isRecommended: {
      type: Boolean,
      default: false,
    },
    localLinks: {
      type: Object,
      required: true,
    },
  },

  setup(props) {
    const { isRecommendVetExperiment } = useSearchData(props.isRecommended);

    return { isRecommendVetExperiment };
  },

  computed: {
    ...mapGetters('questionnaire', [
      'isLoading',
      'showHeaderBackButton',
    ]),
  },

  created() {
    this.$store.commit('setLocalLinks', this.localLinks);
  },

  mounted() {
    this.$layout.calculateNavHeight();
  },

  methods: {
    back() {
      this.$bus.$emit('back');
    },

    toggleFilters() {
      this.$store.commit('search/setShowFilters', 'filter_nav');
    },
  },
};
</script>
